module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.spinner_device) ? _c('GeneralSpinner') : _c('div', [_c('div', {
    staticClass: "tabs-select-style form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_device),
      expression: "selected_device"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select",
      "name": "select"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectDevice()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.selected_device_t))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.name !== 'Irrimation' && device.type !== 'CVMNET4' && device.type !== 'LM4A') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.device_type === 'CVM') ? _c('div', [_c('CvmAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'CVMMINI' || _vm.device_type === 'CVMNET') ? _c('div', [_c('LiteAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'NET4CH') ? _c('div', [_c('Net4Analyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'CEMC6' || _vm.device_type === 'CEMC30' || _vm.device_type === 'CEMC20') ? _c('div', [_c('EnergyAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99f86698"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Device.vue
// module id = 566
// module chunks = 1